import {
  Avatar,
  Chip,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Paper,
  Stack,
} from "@mui/material";
import _ from "lodash";
import React, { useCallback } from "react";
import { Body1, Body2, Caption } from "../../../../components";
import { formatarDataHora } from "../../../../utils/datas";
import { labelStatus, labelStatusColor } from "../users-page-utils";
import OptionsMenu from "../../../../extra-components/options-menu";
import { usersPageSetModal } from "../reducers/users-page-actions";
import UsersPageModal from "../users-page-modal";
import { useDispatch } from "react-redux";

const STR = {
  lastAccess: "Último acesso",
  labelEdit: "EDITAR",
  labelDelete: "EXCLUIR",
  labelUpdatePassword: "ALTERAR SENHA",
  labelVariable: "ATRIBUIR VARIÁVEIS",
  labelMenu: "ATRIBUIR MENU",
  labelStore: "ATRIBUIR LOJA",
};

function UsersPageItem({ id, email, name, avatar, status, dateAccess }) {
  return (
    <Paper sx={{ my: 0.5 }}>
      <ListItem
        secondaryAction={
          <Options id={id} email={email} name={name} status={status} />
        }
      >
        <ListItemAvatar>
          <Avatar src={avatar} alt={_.toUpper(name)}>
            {_.toUpper(name[0])}
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={
            <PrimaryInfo
              name={name}
              status={status}
              dateAccess={dateAccess}
              email={email}
            />
          }
        />
      </ListItem>
    </Paper>
  );
}

const PrimaryInfo = ({ name, status, email, dateAccess }) => {
  return (
    <Stack gap={1.5}>
      <Stack direction="row" gap={1} justifyContent="space-between">
        <Stack>
          <Body1>{name}</Body1>
          <Caption>{email}</Caption>
        </Stack>
        <Chip
          size="small"
          label={labelStatus(status)}
          color={labelStatusColor(status)}
        />
      </Stack>

      <Body2>
        {STR.lastAccess}: {formatarDataHora(dateAccess)}
      </Body2>
    </Stack>
  );
};

const Options = ({ id, name, email, status }) => {
  const dispatch = useDispatch();
  //
  const onDelete = useCallback(() => {
    dispatch(
      usersPageSetModal({
        type: UsersPageModal.modal.DELETE,
        data: id,
      })
    );
  }, [dispatch, id]);
  //
  const onEdit = useCallback(() => {
    dispatch(
      usersPageSetModal({
        type: UsersPageModal.modal.EDIT,
        data: {
          id,
          name,
          email,
          status,
        },
      })
    );
  }, [dispatch, id, name, email, status]);
  const onUpdatePassword = useCallback(() => {
    dispatch(
      usersPageSetModal({
        type: UsersPageModal.modal.UPD_PASSWORD,
        data: id,
      })
    );
  }, [dispatch, id]);
  //
  const onVariables = useCallback(() => {
    dispatch(
      usersPageSetModal({
        type: UsersPageModal.modal.VARIABLE_USER,
        data: {
          id,
        },
      })
    );
  }, [dispatch, id]);
  //
  const onMenus = useCallback(() => {
    dispatch(
      usersPageSetModal({
        type: UsersPageModal.modal.MENU_USER,
        data: id,
      })
    );
  }, [dispatch, id]);
  //
  const onStores = useCallback(() => {
    dispatch(
      usersPageSetModal({
        type: UsersPageModal.modal.STORE_USER,
        data: id,
      })
    );
  }, [dispatch, id]);

  //
  const options = [
    {
      icon: "Edit",
      label: STR.labelEdit,
      onClick: onEdit,
    },
    {
      icon: "VpnKey",
      label: STR.labelUpdatePassword,
      onClick: onUpdatePassword,
    },
    {
      icon: "Mediation",
      label: STR.labelVariable,
      onClick: onVariables,
    },
    {
      icon: "Public",
      label: STR.labelMenu,
      onClick: onMenus,
    },
    {
      icon: "Store",
      label: STR.labelStore,
      onClick: onStores,
    },
    {
      icon: "Delete",
      label: STR.labelDelete,
      onClick: onDelete,
    },
  ];
  return <OptionsMenu options={options} />;
};

export default UsersPageItem;
